const WorkspaceLayout = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="flex flex-col flex-grow flex-shrink min-h-0 bg-ds-accent3-100">
      {children}
    </div>
  );
};

export default WorkspaceLayout;
